import { render, staticRenderFns } from "./MultiUserSelect.vue?vue&type=template&id=bab31138&scoped=true"
import script from "./MultiUserSelect.vue?vue&type=script&lang=js"
export * from "./MultiUserSelect.vue?vue&type=script&lang=js"
import style0 from "./MultiUserSelect.vue?vue&type=style&index=0&id=bab31138&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bab31138",
  null
  
)

export default component.exports